export default {
  tab_list: [//顶部导航
    { label: "全部", value: 32, key: "all" },
    { label: "出售中", value: 4, key: "price" },
    { label: "仓库中", value: 3, key: "store" },
    { label: "回收站", value: 32, key: "recycle" },
    { label: "违规", value: 32, key: "err" }
  ]

}